import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getProductsAPIHelper, getSingleProductAPI } from "../../Redux/helpers/productsAPI";

const initialState = {
    globalproducts: [],
    singleProduct: []
}

export const getGlobalMarketData = createAsyncThunk('products/getglobalmarketData', async (payload, thunkAPI) => {
    try {
        const response = await getProductsAPIHelper(payload);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});

export const getSingleProduct = createAsyncThunk('products/get-single-product', async (id, thunkAPI) => {
    try {
        const response = await getSingleProductAPI(id);

        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
})

const ProductsSlice = createSlice({
    name: 'Products',
    initialState,
    reducers: {
        clearProducts: (state) => {
            state.globalproducts = [];
        },
    },

    extraReducers: (builder) => {
        builder.addCase(getGlobalMarketData.fulfilled, (state, action) => {
            state.globalproducts = action?.payload?.data;
            // console.log("GLOBAL MARKET DATA IN THE REDUCER", JSON.stringify(action.payload))
        })
            .addCase(getGlobalMarketData.rejected, (state, action) => {
                state.error = action.error.message;
            })

            .addCase(getSingleProduct.fulfilled, (state, action) => {
                state.singleProduct = action?.payload?.data;
            })
            .addCase(getSingleProduct.rejected, (state, action) => {
                state.error = action.error.message;
            })

    }
})

export const { clearProducts } = ProductsSlice.actions;
export default ProductsSlice.reducer;